import React from 'react';

import Active from 'assets/svgs/actions/toggle-on.svg';
import {ReactComponent as InActive} from 'assets/svgs/actions/toggle-off.svg';
import './style.scss';

export default function Checkbox(props) {
  return (
    <div
      aria-hidden
      key={props.key}
      onClick={(e) => {
        e.preventDefault();
        if (props.disabled) return;
        props.handleChange(e);
      }}
      className={`toogle-im  ${props.disabled ? 'disabled' : ''} ${
        props.className || ''
      }`}
    >
      {props.enabled ? <img src={Active} alt="on" /> : <InActive />}
    </div>
  );
}
